<div class="mobile-navigation d-flex flex-row align-items-center justify-content-between">
  <div class="navigation" routerLink="/rewards/wallet">
    <span class="material-icons bg-glass mb-1" [ngClass]="textColor"> account_balance_wallet </span>
    <a class="font-size-14" [ngClass]="textColor">{{ 'member.card.wallet' | translate }}</a>
  </div>

  <div class="navigation" routerLink="/payment">
    <span class="material-symbols-outlined bg-glass mb-1" [ngClass]="textColor"> credit_card </span>
    <a class="font-size-14" [ngClass]="textColor">{{ 'member.card.payment' | translate }}</a>
  </div>

  <div class="navigation" routerLink="/challenges">
    <span class="icons material-symbols-outlined bg-glass mb-1" [ngClass]="textColor"> emoji_events </span>
    <a class="font-size-14" [ngClass]="textColor">{{ 'member.card.challenges' | translate }}</a>
  </div>

  <div class="navigation" routerLink="/rewards/raffles">
    <span class="material-symbols-outlined bg-glass mb-1" [ngClass]="textColor"> redeem </span>
    <a class="font-size-14" [ngClass]="textColor">{{ 'member.card.prize.draw' | translate }}</a>
  </div>
</div>
